/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StatusC7eEnum } from './StatusC7eEnum';
import {
    StatusC7eEnumFromJSON,
    StatusC7eEnumFromJSONTyped,
    StatusC7eEnumToJSON,
    StatusC7eEnumToJSONTyped,
} from './StatusC7eEnum';
import type { AerialImagesListCenter } from './AerialImagesListCenter';
import {
    AerialImagesListCenterFromJSON,
    AerialImagesListCenterFromJSONTyped,
    AerialImagesListCenterToJSON,
    AerialImagesListCenterToJSONTyped,
} from './AerialImagesListCenter';

/**
 * Custom serializer that returns plume data for the map.
 * @export
 * @interface PlumeImage
 */
export interface PlumeImage {
    /**
     * 
     * @type {string}
     * @memberof PlumeImage
     */
    readonly id: string;
    /**
     * 
     * @type {string}
     * @memberof PlumeImage
     */
    originalImage: string;
    /**
     * 
     * @type {string}
     * @memberof PlumeImage
     */
    tiledImage: string;
    /**
     * Returns bounds of image polygon.
     * @type {Array<any>}
     * @memberof PlumeImage
     */
    readonly bounds: Array<any>;
    /**
     * 
     * @type {AerialImagesListCenter}
     * @memberof PlumeImage
     */
    center?: AerialImagesListCenter | null;
    /**
     * 
     * @type {StatusC7eEnum}
     * @memberof PlumeImage
     */
    status?: StatusC7eEnum;
    /**
     * 
     * @type {Date}
     * @memberof PlumeImage
     */
    takenAt: Date;
    /**
     * 
     * @type {Array<Date>}
     * @memberof PlumeImage
     */
    readonly matchedAt: Array<Date>;
    /**
     * If this should be hidden in the map by default.
     * @type {boolean}
     * @memberof PlumeImage
     */
    readonly defaultHide: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PlumeImage
     */
    isTiled?: boolean;
}



/**
 * Check if a given object implements the PlumeImage interface.
 */
export function instanceOfPlumeImage(value: object): value is PlumeImage {
    if (!('id' in value) || value['id'] === undefined) return false;
    if ((!('originalImage' in (value as Record<string, any>)) && !('original_image' in (value as Record<string, any>))) || ((value as Record<string, any>)['originalImage'] === undefined && (value as Record<string, any>)['original_image'] === undefined)) return false;
    if ((!('tiledImage' in (value as Record<string, any>)) && !('tiled_image' in (value as Record<string, any>))) || ((value as Record<string, any>)['tiledImage'] === undefined && (value as Record<string, any>)['tiled_image'] === undefined)) return false;
    if (!('bounds' in value) || value['bounds'] === undefined) return false;
    if ((!('takenAt' in (value as Record<string, any>)) && !('taken_at' in (value as Record<string, any>))) || ((value as Record<string, any>)['takenAt'] === undefined && (value as Record<string, any>)['taken_at'] === undefined)) return false;
    if ((!('matchedAt' in (value as Record<string, any>)) && !('matched_at' in (value as Record<string, any>))) || ((value as Record<string, any>)['matchedAt'] === undefined && (value as Record<string, any>)['matched_at'] === undefined)) return false;
    if ((!('defaultHide' in (value as Record<string, any>)) && !('default_hide' in (value as Record<string, any>))) || ((value as Record<string, any>)['defaultHide'] === undefined && (value as Record<string, any>)['default_hide'] === undefined)) return false;
    return true;
}

export function PlumeImageFromJSON(json: any): PlumeImage {
    return PlumeImageFromJSONTyped(json, false);
}

export function PlumeImageFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlumeImage {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'originalImage': json['original_image'],
        'tiledImage': json['tiled_image'],
        'bounds': json['bounds'],
        'center': json['center'] === undefined ? undefined : json['center'] === null ? null : AerialImagesListCenterFromJSON(json['center']),
        'status': json['status'] == null ? undefined : StatusC7eEnumFromJSON(json['status']),
        'takenAt': (new Date(json['taken_at'])),
        'matchedAt': json['matched_at'],
        'defaultHide': json['default_hide'],
        'isTiled': json['is_tiled'] == null ? undefined : json['is_tiled'],
    };
}

export function PlumeImageToJSON(json: any): PlumeImage {
    return PlumeImageToJSONTyped(json, false);
}

export function PlumeImageToJSONTyped(value?: Omit<PlumeImage, 'id'|'bounds'|'matchedAt'|'defaultHide'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'original_image': value['originalImage'],
        'tiled_image': value['tiledImage'],
        'center': AerialImagesListCenterToJSON(value['center']),
        'status': StatusC7eEnumToJSON(value['status']),
        'taken_at': value['takenAt'].toISOString(),
        'is_tiled': value['isTiled'],
    };
}

